export default __webpack_public_path__ + "06bc4483c5464760a5bd35de3b60c5e4.png";